// extracted by mini-css-extract-plugin
module.exports = {"triggerWrapper":"formOptions_triggerWrapper__BqYlT","trigger":"formOptions_trigger__Uis7W","menu":"formOptions_menu__BFRZR"};